export interface CventReaction {
  reactionType?: number;
  reactionName: string;
}

// Cvent's enum has no celebrate or idea value yet (WEBINAR-72749), so they publish a name only.
const CVENT_REACTIONS: Record<string, CventReaction> = {
  clap: { reactionType: 0, reactionName: 'Clap' },
  thumbs_up: { reactionType: 1, reactionName: 'Like' },
  laugh: { reactionType: 4, reactionName: 'Laugh' },
  heart: { reactionType: 5, reactionName: 'Love' },
  celebrate: { reactionName: 'Celebrate' },
  idea: { reactionName: 'Idea' }
};

export function mapReactionToCvent(reactionId: string): CventReaction {
  return CVENT_REACTIONS[reactionId] ?? { reactionName: reactionId };
}
